module.exports = __webpack_public_path__ + "img/custom-marker.svg?307c8941a2d69c1d14ad4fd4999ef3e5";